// extracted by mini-css-extract-plugin
module.exports = {"notfound":"ShopCardList_notfound__CDDIJ","notfoundTitle":"ShopCardList_notfoundTitle__xzpQr","notfoundText":"ShopCardList_notfoundText__FspUg","list":"ShopCardList_list__inN1T"};